import { ChevronRightIcon, type IconProps } from "@salt-ds/icons";

export const BreadcrumbsSeparator = (props: IconProps) => (
  <ChevronRightIcon {...props} />
);
